// src/features/orders/components/OrderTable.tsx
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { SuperAdminOrder } from '../types/order.types';
import { OrderStatusBadge } from './OrderStatusBadge';

export interface OrderTableProps {
  orders: SuperAdminOrder[];
}

/**
 * Order list table. Presentation only — takes its rows as a prop
 * and stays decoupled from the API hook. Same
 * shape as customers/components/CustomerTable.tsx and
 * services/components/ServiceTable.tsx: wrapped in the shared
 * glass-card `Card` primitive (noPadding, table owns its own cell
 * padding) with a horizontal-scroll rail for narrow viewports.
 *
 * Rows are read-only because the existing workspace still uses a mock
 * detail contract and is not part of this list integration.
 */
export function OrderTable({ orders }: OrderTableProps) {
  return (
    <div className="vania-orders-table-scroll">
        <table className="vania-orders-table">
          <thead>
            <tr>
              <th>شناسه سفارش</th>
              <th>تننت</th>
              <th>مشتری</th>
              <th>سرویس</th>
              <th>مبلغ</th>
              <th>وضعیت</th>
              <th>تاریخ ثبت</th>
              <th>آخرین به‌روزرسانی</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="vania-orders-table-row">
                <td className="vania-orders-table-name" dir="ltr">{formatPersianNumber(order.id)}</td>
                <td>{order.tenant?.name ?? order.tenant?.slug ?? 'در دسترس نیست'}</td>
                <td>{order.customer?.name ?? (order.customer?.telegram_id ? formatPersianNumber(order.customer.telegram_id) : 'در دسترس نیست')}</td>
                <td>{order.service?.name ?? 'در دسترس نیست'}</td>
                <td dir="ltr">{order.amount === null ? 'در دسترس نیست' : formatPersianNumber(order.amount)}</td>
                <td>
                  <OrderStatusBadge status={order.status} />
                </td>
                <td dir="ltr">{formatSolarDate(order.created_at)}</td>
                <td dir="ltr">{order.updated_at ? formatSolarDate(order.updated_at) : 'در دسترس نیست'}</td>
                <td><Link className="vania-orders-row-action" to={`/orders/${order.id}`} aria-label="مشاهده سفارش" title="مشاهده"><Eye size={14} aria-hidden="true" /><span className="sr-only">مشاهده</span></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
}
